const e = {
  name: "ArrowCircleUpFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM15.9997 13.4142L17.4139 12L11.9997 6.58582L6.58545 12L7.99966 13.4142L10.9998 10.4141V17.0001H12.9998V10.4144L15.9997 13.4142Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as ArrowCircleUpFilled
};
